"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockProductsGenerator = exports.mockSerializedProducts = exports.mockSerializedServiceProducts = exports.mockSerializedDeliveryProducts = exports.mockSerializedStockedProducts = exports.mockSerializedProductBlueprints = void 0;
const productUnserializeFactory_1 = require("../../../helpers/productUnserializeFactory");
const pricingRules_1 = require("../../../models/pricingRules");
const restrictions_1 = require("../../../models/restrictions");
const Product_1 = require("../../../models/Product");
const mockRetailLocations_1 = require("./mockRetailLocations");
exports.mockSerializedProductBlueprints = [
    {
        productId: "FFBC",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Burrito",
        description: "Made with your choice of filling, jasmine rice, pinto beans, freshly made salsas, cheese, sour cream and lettuce all wrapped in a fluffy 12 inch flour tortilla.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_productPreview/Burrito.jpg",
        retailPrice: 12.4,
        products: [
            {
                productId: "FITOWH12",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Soft flour tortilla 12 Inch",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/White_Tortilla.png",
                retailPrice: 0.7,
                currentStockLevel: -9,
                isStandalone: false,
                category: {
                    name: "tortillas",
                    label: "Choose tortilla",
                    priority: 2,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.70"
                },
                defaultLevel: 1,
                quantityPerServe: 1
            },
            {
                productId: "FIFPCL10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Cos lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 8,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.05
            },
            {
                productId: "FICHCH10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cheese.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "cheese",
                    label: "Choose cheese",
                    priority: 6,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.02
            },
            {
                productId: "FRPVPI10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Pinto beans",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "beans",
                    label: "Beans?",
                    priority: 4,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FICHSC10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Sour cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Sour_Cream.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sourCream",
                    label: "Choose sour cream",
                    priority: 5,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.025
            },
            {
                productId: "FIPVJP10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Jalapeños",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 8,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 5
            },
            {
                productId: "FIFPLM10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Squeeze of Lime",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 0,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 8,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.00"
                },
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSRCWH10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "White rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/White_Rice.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "rice",
                    label: "Choose rice",
                    priority: 3,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSSLTO10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Tomato salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "salsas",
                    label: "Choose salsas",
                    priority: 10,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCN10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Corn salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Corn_Salsa.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "salsas",
                    label: "Choose salsas",
                    priority: 10,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCO10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Coriander & onion salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Onion_Coriander_Salsa.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "salsas",
                    label: "Choose salsas",
                    priority: 10,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPTBF10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Barbacoa Beef",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 4,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 1,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "4.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FISACH10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Chipotle",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAGA10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Garlic",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISARC10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Red chilli",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABQ10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Secret BBQ",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAVD10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Verde",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABA10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Basilo",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISATZ10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Trezigo",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FSGCGC10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 2,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "guacamole",
                    label: "Guacamole?",
                    priority: 7,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "2.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.05
            },
            {
                productId: "FSRCBK10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Black rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Black_Rice.png",
                retailPrice: 1,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "rice",
                    label: "Choose rice",
                    priority: 3,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "1.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.08
            },
            {
                productId: "FSSLIQ10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Salsa IQ",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/IQ_Salsa.png",
                retailPrice: 1.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "salsas",
                    label: "Choose salsas",
                    priority: 10,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "1.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.08
            },
            {
                productId: "FIPTCF10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 4,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 1,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "4.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTCH10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Chicken",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 4,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 1,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "4.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTLM10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 4,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 1,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "4.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTPK10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 4,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 1,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "4.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FICHCH20",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Vegan Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Vegan-Cheese.png",
                retailPrice: 1,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "cheese",
                    label: "Choose cheese",
                    priority: 6,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "1.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FICHSC20",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Vegan Sour Cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Vegan_Sour_Cream.png",
                retailPrice: 1,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "sourCream",
                    label: "Choose sour cream",
                    priority: 5,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "1.00"
                },
                defaultLevel: 0,
                quantityPerServe: 0.025
            },
            {
                productId: "FITOBK10",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Black rice tortilla 11 Inch",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Black_Rice_Tortilla.png",
                retailPrice: 2,
                currentStockLevel: -1,
                isStandalone: false,
                category: {
                    name: "tortillas",
                    label: "Choose tortilla",
                    priority: 2,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "2.00"
                },
                defaultLevel: 0,
                quantityPerServe: 1
            },
            {
                productId: "FICPCC20",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Crushed corn chips",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/corn_chips.png",
                retailPrice: 0.5,
                currentStockLevel: 0,
                isStandalone: false,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 8,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 0.012
            },
            {
                productId: "FIPTVGWH",
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                title: "Vegetarian",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Vegetarian_Shadow.png",
                retailPrice: 4,
                currentStockLevel: 999,
                isStandalone: false,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 1,
                    description: null,
                    hasAddButtons: false,
                    hasDoubleSelectionButtons: true,
                    extrasLabel: null,
                    extraPrice: "4.00"
                },
                defaultLevel: 0,
                quantityPerServe: 999
            },
            {
                productId: "NOSAUCE",
                retailLocationId: null,
                title: "No Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/remove-icon-1.png",
                retailPrice: 0,
                currentStockLevel: 1,
                isStandalone: false,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 11,
                    description: null,
                    hasAddButtons: true,
                    hasDoubleSelectionButtons: false,
                    extrasLabel: null,
                    extraPrice: "0.50"
                },
                defaultLevel: 0,
                quantityPerServe: 1
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMutuallyExclusive,
                category: "tortillas",
                productIds: ["FITOWH12", "FITOBK10"],
                min: 1,
                max: 1
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FIFPCL10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.categoryMutuallyExclusive,
                category: "cheese",
                productIds: ["FICHCH10", "FICHCH20"],
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FRPVPI10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.categoryMutuallyExclusive,
                category: "sourCream",
                productIds: ["FICHSC10", "FICHSC20"],
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FIPVJP10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FIFPLM10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.categoryMutuallyExclusive,
                category: "rice",
                productIds: ["FSRCWH10", "FSRCBK10"],
                min: 1,
                max: 1
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FSSLTO10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FSSLCN10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FSSLCO10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                category: "fillings",
                min: 1,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                category: "sauces",
                min: 1,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FSGCGC10",
                min: 0,
                max: 1
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FSRCBK10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FSSLIQ10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FICHCH20",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FICHSC20",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FITOBK10",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FICPCC20",
                min: 0,
                max: 2
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "FIPTVGWH",
                min: null,
                max: 1
            },
            {
                name: restrictions_1.TRestrictionRuleName.disallowedWhen,
                productIds: [
                    "FIPTBF10",
                    "FIPTCF10",
                    "FIPTCH10",
                    "FIPTLM10",
                    "FIPTPK10"
                ],
                dependencies: ["FIPTVGWH"]
            },
            {
                name: restrictions_1.TRestrictionRuleName.itemMinMax,
                productId: "NOSAUCE",
                min: null,
                max: 1
            },
            {
                name: restrictions_1.TRestrictionRuleName.disallowedWhen,
                productIds: [
                    "FISACH10",
                    "FISAGA10",
                    "FISARC10",
                    "FISABQ10",
                    "FISAVD10",
                    "FISABA10",
                    "FISATZ10"
                ],
                dependencies: ["NOSAUCE"]
            },
            {
                name: restrictions_1.TRestrictionRuleName.disallowedWhen,
                productIds: ["FSSLTO10", "FSSLCN10", "FSSLCO10"],
                dependencies: ["FSSLIQ10"]
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FITOWH12"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FIFPCL10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FICHCH10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FRPVPI10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FICHSC10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FIPVJP10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FIFPLM10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FSRCWH10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FSSLTO10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FSSLCN10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FSSLCO10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                quantity: 1,
                category: "fillings"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                quantity: 1,
                category: "sauces"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 0,
                productId: "FSGCGC10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 0,
                productId: "FSRCBK10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 0,
                productId: "FSSLIQ10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 0,
                productId: "FICHCH20"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 0,
                productId: "FICHSC20"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 0,
                productId: "FITOBK10"
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                quantity: 1,
                productId: "FICPCC20"
            }
        ],
        category: {
            name: "mains",
            label: "Burritos and Bowls",
            priority: 1,
            displaySize: Product_1.TProductDisplaySize.Large
        }
    },
    {
        productId: "FFBI",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Burrito IQ",
        description: "Sure to get your mouth watering and brain ticking. Served in a warm 12 inch tortilla, with your choice of filling, our Salsa IQ®, guacamole, cos lettuce and black rice infused with spirulina & amaranth seeds.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Burrito_IQ.jpg",
        retailPrice: 14.4,
        category: {
            name: "favourites",
            label: "Favourites",
            priority: 2
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.05
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 5
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSRCBK10",
                title: "Black Rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Black_Rice.png",
                retailPrice: 12.5,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSSLIQ10",
                title: "Salsa IQ",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/IQ_Salsa.png",
                retailPrice: 18.75,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.045
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSRCBK10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLIQ10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFBP",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Power Burrito",
        description: "Packed 50% more of your choice of filling, our salsas, cos lettuce and superfoods including our spirulina-infused black rice with amaranth seeds.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Power_Burrito.jpg",
        retailPrice: 16.4,
        category: {
            name: "favourites",
            label: "Favourites",
            priority: 2
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.05
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 5
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSRCBK10",
                title: "Black Rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Black_Rice.png",
                retailPrice: 12.5,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCN10",
                title: "Corn Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Corn_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCO10",
                title: "Corianda and Onion Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Onion_Coriander_Salsa.png",
                retailPrice: 33.33,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.09
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSRCBK10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCN10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFBS",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Small Burrito",
        description: "Our Burrito served in a smaller 10 inch tortilla size.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Chikito.jpg",
        retailPrice: 9.9,
        category: {
            name: "mains",
            label: "Pick your style",
            priority: 1
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.025
            },
            {
                productId: "FICHCH10",
                title: "Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cheese.png",
                retailPrice: 25,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.02
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FICHSC10",
                title: "Sour Cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Sour_Cream.png",
                retailPrice: 20,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 10,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 3
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSRCWH10",
                title: "White Rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/White_Rice.png",
                retailPrice: 6.25,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.04
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FSSLCN10",
                title: "Corn Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Corn_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FSSLCO10",
                title: "Corianda and Onion Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Onion_Coriander_Salsa.png",
                retailPrice: 33.33,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.05
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.05
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.05
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.05
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.05
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.045
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHCH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHSC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSRCWH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCN10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFIP",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Chips",
        description: "Crispy corn chips dusted with Zam Spice, available with large sides of guacamole and/or your choice of sauce.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Chips.jpg",
        retailPrice: 1.9,
        category: {
            name: "sides",
            label: "Something smaller",
            priority: 3
        },
        products: [
            {
                productId: "FICPCC10",
                title: "Corn Chips",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/corn_chips.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.05
            }
        ],
        restrictions: [],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICPCC10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFNL",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Nachos",
        description: "Crispy corn chips topped with your choice of filling, melted cheese, guacamole, sour cream, and our tomato salsa.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Nachos.jpg",
        retailPrice: 13.9,
        category: {
            name: "mains",
            label: "Pick your style",
            priority: 1
        },
        products: [
            {
                productId: "FICPCC10",
                title: "Corn Chips",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/corn_chips.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.07
            },
            {
                productId: "FICHCH10",
                title: "Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cheese.png",
                retailPrice: 25,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.04
            },
            {
                productId: "FICHSC10",
                title: "Sour Cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Sour_Cream.png",
                retailPrice: 20,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 10,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.025
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.045
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.045
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.12
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.12
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.12
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.12
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.12
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.09
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICPCC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHCH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHSC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFNS",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Small Nachos",
        description: "Crispy corn chips with their choice of filling, cheese, sour cream, guacamole and tomato salsa.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Small_Nachos.jpg",
        retailPrice: 5.9,
        category: {
            name: "sides",
            label: "Something smaller",
            priority: 3
        },
        products: [
            {
                productId: "FICPCC10",
                title: "Corn Chips",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/corn_chips.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FICHCH10",
                title: "Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cheese.png",
                retailPrice: 25,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.02
            },
            {
                productId: "FICHSC10",
                title: "Sour Cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Sour_Cream.png",
                retailPrice: 20,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 10,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.025
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.06
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICPCC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHCH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHSC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFTD",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Dos Capas",
        description: "A hard shell taco wrapped in a warm soft tortilla Think of it as a sensory joy ride!",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Dos_Capas.jpg",
        retailPrice: 5.5,
        category: {
            name: "sides",
            label: "Something smaller",
            priority: 3
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FICHCH10",
                title: "Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cheese.png",
                retailPrice: 25,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FICHSC10",
                title: "Sour Cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Sour_Cream.png",
                retailPrice: 20,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 10,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 3
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FSSLCN10",
                title: "Corn Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Corn_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FSSLCO10",
                title: "Corianda and Onion Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Onion_Coriander_Salsa.png",
                retailPrice: 33.33,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.025
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHCH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHSC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCN10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFTH",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Hard and Soft Tacos",
        description: "Your choice or either a soft flour tortilla or crunchy corn flour taco with your favourite filling, cheese, sour cream, salsas and cos lettuce.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Taco.jpg",
        retailPrice: 5,
        category: {
            name: "sides",
            label: "Something smaller",
            priority: 3
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FICHCH10",
                title: "Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cheese.png",
                retailPrice: 25,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FICHSC10",
                title: "Sour Cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Sour_Cream.png",
                retailPrice: 20,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 10,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 3
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FSSLCN10",
                title: "Corn Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Corn_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FSSLCO10",
                title: "Corianda and Onion Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Onion_Coriander_Salsa.png",
                retailPrice: 33.33,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.01
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.01
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.04
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.025
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHCH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHSC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCN10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFWC",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Bowl",
        description: "Your choice of filling with jasmine rice, pinto beans, cheese, sour cream, salsas and cos lettuce.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Bowl.jpg",
        retailPrice: 12.4,
        category: {
            name: "mains",
            label: "Pick your style",
            priority: 1
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.05
            },
            {
                productId: "FICHCH10",
                title: "Cheese",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cheese.png",
                retailPrice: 25,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.02
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FICHSC10",
                title: "Sour Cream",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Sour_Cream.png",
                retailPrice: 20,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 10,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.025
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 5
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSRCWH10",
                title: "White Rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/White_Rice.png",
                retailPrice: 6.25,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCN10",
                title: "Corn Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Corn_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCO10",
                title: "Corianda and Onion Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Onion_Coriander_Salsa.png",
                retailPrice: 33.33,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.045
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHCH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FICHSC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSRCWH10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCN10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFWI",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Bowl IQ",
        description: "Your choice of filling with our spirulina-infused black rice with amaranth seeds, guacamole, fresh salsas with our Salsa IQ and cos lettuce.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Bowl_IQ.jpg",
        retailPrice: 14.4,
        category: {
            name: "favourites",
            label: "Favourites",
            priority: 2
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.05
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 5
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSRCBK10",
                title: "Black Rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Black_Rice.png",
                retailPrice: 12.5,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSSLIQ10",
                title: "Salsa IQ",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/IQ_Salsa.png",
                retailPrice: 18.75,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.045
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.1
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSRCBK10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLIQ10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            }
        ]
    },
    {
        productId: "FFWP",
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        title: "Powerbowl",
        description: "Packed with extra protein and served with our nutrient-rich, spirulina-infused black rice with amaranth seeds, pinto beans, salsas and cos lettuce.",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/_articlePreview/Powerbowl.jpg",
        retailPrice: 14.4,
        category: {
            name: "favourites",
            label: "Favourites",
            priority: 2
        },
        products: [
            {
                productId: "FIFPCL10",
                title: "Lettuce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lettuce.png",
                retailPrice: 10,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.05
            },
            {
                productId: "FRPVPI10",
                title: "Bean Pinto",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pinto_Bean.png",
                retailPrice: 0,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FIPVJP10",
                title: "Jalapenos Sliced",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Jalapeno.png",
                retailPrice: 0.1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 400,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 5
            },
            {
                productId: "FIFPLM10",
                title: "Lime Fresh",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/zambrero_fresh_limes_170922_071516.png",
                retailPrice: 1,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 25,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.001
            },
            {
                productId: "FSRCBK10",
                title: "Black Rice",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Black_Rice.png",
                retailPrice: 12.5,
                category: {
                    name: "base",
                    label: "Choose base",
                    priority: 1
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.08
            },
            {
                productId: "FSSLTO10",
                title: "Tomato Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Tomato_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCN10",
                title: "Corn Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Corn_Salsa.png",
                retailPrice: 16.67,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.03
            },
            {
                productId: "FSSLCO10",
                title: "Corianda and Onion Salsa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Onion_Coriander_Salsa.png",
                retailPrice: 33.33,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.015
            },
            {
                productId: "FIPTBF10",
                title: "Beef Barbacoa",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Beef.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FISACH10",
                title: "Chipotle Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chipotle.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 3,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAGA10",
                title: "Garlic Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Garlic.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISARC10",
                title: "Chilli Red Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Red_Chilli_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 1,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABQ10",
                title: "BBQ Secret Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Secret_BBQ_Sauce.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISAVD10",
                title: "Verde Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Verde.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 4,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISABA10",
                title: "Basilo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Basilo.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 5,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FISATZ10",
                title: "Trezigo Sauce",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Trezigo1.png",
                retailPrice: 25,
                category: {
                    name: "sauces",
                    label: "Choose sauce",
                    priority: 4
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 2,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.02
            },
            {
                productId: "FIPTCF10",
                title: "Cauliflower",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Cauliflower.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 15,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FIPTCH10",
                title: "Chicken Original",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Chicken.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 40,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FIPTLM10",
                title: "Lamb",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lamb.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FIPTPK10",
                title: "Pulled Pork",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pork.png",
                retailPrice: 30,
                category: {
                    name: "fillings",
                    label: "Choose filling",
                    priority: 2
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 30,
                isStandalone: false,
                defaultLevel: 0,
                quantityPerServe: 0.15
            },
            {
                productId: "FSGCGC10",
                title: "Guacamole",
                description: null,
                imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Fresh-Guac_191204_223559.png",
                retailPrice: 44.44,
                category: {
                    name: "toppings",
                    label: "Choose toppings",
                    priority: 3
                },
                retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
                currentStockLevel: 20,
                isStandalone: false,
                defaultLevel: 1,
                quantityPerServe: 0.09
            }
        ],
        restrictions: [
            {
                name: restrictions_1.TRestrictionRuleName.categoryMinMax,
                min: 1,
                max: null,
                category: "fillings"
            }
        ],
        pricingRules: [
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPCL10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FRPVPI10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIPVJP10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FIFPLM10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSRCBK10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLTO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCN10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSSLCO10",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "fillings",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByCategory,
                category: "sauces",
                quantity: 1
            },
            {
                name: pricingRules_1.TPricingRuleName.complementaryByItem,
                productId: "FSGCGC10",
                quantity: 1
            }
        ]
    }
];
exports.mockSerializedStockedProducts = [
    {
        productId: "BNITLPLE50",
        title: "Lipton Iced Tea Lemon 500ml",
        description: "Lemon",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Lipton_Iced_Tea_Lemon_500ml.jpg",
        retailPrice: 4,
        category: {
            name: "drinks",
            label: "Drinks",
            priority: 4
        },
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        currentStockLevel: 5,
        isStandalone: true
    },
    {
        productId: "BNJUCHAJ30",
        title: "Charlies Honest Ap Juice 300ml",
        description: "Apple Juice",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Charlies_Honest_Ap_Juice_300ml.jpg",
        retailPrice: 4,
        category: {
            name: "drinks",
            label: "Drinks",
            priority: 4
        },
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        currentStockLevel: 5,
        isStandalone: true
    },
    {
        productId: "BNJUPTOJ25",
        title: "Pop Tops Orange 250ml",
        description: "Orange Juice",
        imageUrl: "https://dph95f73vdxmz.cloudfront.net/uploads/Pop_Tops_Orange_250ml.jpg",
        retailPrice: 4,
        category: {
            name: "drinks",
            label: "Drinks",
            priority: 4
        },
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        currentStockLevel: 5,
        isStandalone: true
    }
];
exports.mockSerializedDeliveryProducts = [
    {
        productId: "DELIVERY",
        title: "Delivery cost",
        description: null,
        imageUrl: null,
        retailPrice: 4.99,
        category: null,
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        currentStockLevel: null,
        isStandalone: true
    }
];
exports.mockSerializedServiceProducts = [
    {
        productId: "SERVICE",
        title: "Service fee",
        description: null,
        imageUrl: null,
        retailPrice: 8.00,
        category: null,
        retailLocationId: mockRetailLocations_1.mockRetailLocations[0].retailLocationId,
        currentStockLevel: null,
        isStandalone: true
    }
];
exports.mockSerializedProducts = [
    ...exports.mockSerializedProductBlueprints,
    ...exports.mockSerializedStockedProducts,
    ...exports.mockSerializedDeliveryProducts,
    ...exports.mockSerializedServiceProducts
];
/**
 * Generate a mock product list for a specific retail location.
 */
const mockProductsGenerator = (retailLocationId) => {
    const mockSerializedProductsForRetailLocation = exports.mockSerializedProducts.map((mockSerializedProduct) => {
        mockSerializedProduct.retailLocationId = retailLocationId;
        return mockSerializedProduct;
    });
    const mockProducts = mockSerializedProductsForRetailLocation.map(productUnserializeFactory_1.productUnserializeFactory);
    return mockProducts;
};
exports.mockProductsGenerator = mockProductsGenerator;
//# sourceMappingURL=mockProducts.js.map